/**
 * What a name may be made of — for people, venues and assets alike.
 * Mirrors isValidName() / NAME_RE in lib.js — keep the two in step.
 *
 * Allowed: letters of any script, the combining marks those scripts need,
 * decimal digits, spaces, and the three connectors real names use — apostrophe,
 * hyphen and full stop. Refused: every emoji, symbol, bracket and punctuation
 * sign, "&" included.
 *
 * `\p{L}` alone would not do: Malayalam and Devanagari build a syllable from a
 * letter plus combining vowel signs, which are marks (`\p{M}`), so a name typed
 * in either script would be rejected a character or two in. The zero-width
 * non-joiner and joiner are allowed for the same reason — Malayalam uses them to
 * shape chillu and conjunct forms — and cannot smuggle an emoji through, since
 * every character an emoji is built from is refused anyway.
 */
const NAME_RE = /^[\p{L}\p{M}\p{Nd}‌‍ .'-]+$/u;

export const isValidName = (value: string): boolean => {
  const v = (value ?? '').trim();
  return v.length > 0 && NAME_RE.test(v);
};
